const defaults = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  withSymbol: true
};

const currency = (
  value: number,
  options: Partial<typeof defaults> = defaults
) => {
  const opts = {
    ...defaults,
    ...options
  };

  return `${opts.withSymbol ? '$' : ''}${Number(
    Math.abs(value) || 0
  ).toLocaleString(undefined, opts)}`;
};

export const removeZeroCents = (price: string) =>
  price.toString().replace('.00', '');

export const removeCents = (price: string) =>
  price.slice(0, price.indexOf('.'));

export default currency;
